import { gql } from '@lichtblick/apollo';

export const GET_MYSELF = gql`
  query getMyself {
    getUser_V1 {
      data {
        id
        firstName
        lastName
        roles {
          name
        }
      }
    }
  }
`;

export const GET_QM_USERS = gql`
  query getUsers {
    getUsers_V1(input: { roleId: 4 }) {
      error
      data {
        salutation
        phone
        mobilePhone
        jobTitle
        id
        eMail
        firstName
        lastName
        roles {
          id
          name
        }
      }
    }
  }
`;
